import { StyleSheet } from 'react-native';
import { WARMUP_COLORS } from '../../../src/quiz/constants/warmup.constants';
import { SLINGSHOT_ACCENT } from '../../../src/quiz/constants/slingshot.constants';

export const fullscreenStyles = StyleSheet.create({
  backButton: {
    position: 'absolute',
    top: 8,
    left: 8,
    zIndex: 50,
    width: 36,
    height: 36,
    borderRadius: 18,
    backgroundColor: 'rgba(0,0,0,0.5)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  backArrow: {
    color: '#F7FAFC',
    fontSize: 20,
    fontWeight: '800',
    marginTop: -2,
  },
});

export const slingshotViewStyles = StyleSheet.create({
  fullscreenContainer: {
    backgroundColor: '#0F0A1A',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 100,
  },

  container: { flex: 1 },

  // The game canvas fills the full available body — no margins, no rounding.
  canvasWrap: {
    flex: 1,
    overflow: 'hidden',
    backgroundColor: '#0F0A1A',
  },

  coinRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 7,
    paddingHorizontal: 18,
    paddingBottom: 10,
    flexWrap: 'wrap',
  },
  coinDot: { width: 12, height: 12, borderRadius: 9999, backgroundColor: WARMUP_COLORS.amber },
  coinProgress: { fontSize: 13, fontWeight: '700', color: WARMUP_COLORS.textDim },
  bestText: { fontSize: 12, fontWeight: '700', color: SLINGSHOT_ACCENT },
  capBanner: { fontSize: 12, fontWeight: '800', color: WARMUP_COLORS.amber },

  // Overlays cover the canvas for loading / error / completion.
  overlay: {
    ...StyleSheet.absoluteFillObject,
    alignItems: 'center',
    justifyContent: 'center',
    gap: 14,
    padding: 24,
    backgroundColor: 'rgba(15,10,26,0.82)',
  },
  message: { color: WARMUP_COLORS.textDim, fontSize: 14, fontWeight: '500', textAlign: 'center' },

  retryButton: {
    backgroundColor: SLINGSHOT_ACCENT,
    borderRadius: 12,
    paddingVertical: 12,
    paddingHorizontal: 28,
  },
  retryText: { color: WARMUP_COLORS.textOnBright, fontSize: 15, fontWeight: '800' },
  ghostButton: {
    borderRadius: 12,
    paddingVertical: 12,
    paddingHorizontal: 24,
    borderWidth: 1.5,
    borderColor: WARMUP_COLORS.borderPurple,
  },
  ghostText: { color: WARMUP_COLORS.text, fontSize: 15, fontWeight: '700' },
  pressedDim: { opacity: 0.7 },

  endTitle: { fontSize: 22, fontWeight: '900', color: WARMUP_COLORS.text, textAlign: 'center' },
  endSub: { fontSize: 15, fontWeight: '600', color: WARMUP_COLORS.textDim },
  endBest: { fontSize: 14, fontWeight: '800', color: WARMUP_COLORS.amber },
  endButtons: { flexDirection: 'row', gap: 12, marginTop: 6, alignItems: 'center' },

  coinBeat: { position: 'absolute', top: '38%', alignSelf: 'center' },
  coinBeatText: { fontSize: 30, fontWeight: '900', color: WARMUP_COLORS.amber, textShadowColor: 'rgba(0,0,0,0.5)', textShadowRadius: 6 },

  // Exit summary card
  summaryCard: {
    backgroundColor: WARMUP_COLORS.card,
    borderRadius: 18,
    borderWidth: 1.5,
    borderColor: WARMUP_COLORS.borderPurple,
    paddingVertical: 20,
    paddingHorizontal: 22,
    gap: 14,
    minWidth: 300,
    maxWidth: 360,
    alignItems: 'center',
  },
  summaryRows: { alignSelf: 'stretch', gap: 8 },
  summaryRow: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' },
  summaryLabel: { fontSize: 14, fontWeight: '600', color: WARMUP_COLORS.textDim },
  summaryValue: { fontSize: 15, fontWeight: '800', color: WARMUP_COLORS.text },
  summaryValueHot: { color: WARMUP_COLORS.amber },

  // Milestone celebration (every 10th clear) — reuses the summary card; "major" quarters get the accent rim.
  milestoneMajor: { borderColor: SLINGSHOT_ACCENT, borderWidth: 2 },
  milestoneBadge: { fontSize: 40 },
  milestoneHype: { fontSize: 16, fontWeight: '800', color: SLINGSHOT_ACCENT, textAlign: 'center' },
});
